import { Controller } from "stimulus"

// Bugfix 32 (#1566): de min- en plusknop naast gewicht en herhalingen in de
// sportersomgeving. Past het veld aan en verstuurt het formulier, precies
// zoals een handmatig ingetypte waarde (sporter-set#opslaan).
export default class extends Controller {
  static targets = ["veld"]
  static values = { stap: { type: Number, default: 1 } }

  min(event) { this.zet(event, -1) }

  plus(event) { this.zet(event, 1) }

  zet(event, richting) {
    event.preventDefault()
    if (!this.hasVeldTarget) return
    const veld = this.veldTarget
    let huidig = parseFloat(String(veld.value || veld.placeholder || "0").replace(",", "."))
    if (isNaN(huidig)) huidig = 0
    let nieuw = Math.max(0, huidig + richting * this.stapValue)
    nieuw = Math.round(nieuw * 100) / 100
    veld.value = Number.isInteger(nieuw) ? String(nieuw) : String(nieuw).replace(".", ",")
    const form = veld.closest("form")
    if (form) form.requestSubmit()
  }
}
